import useReactHookForm from "hooks/useReactHookForm";

import { useAppDispatch, useAppSelector } from "hooks/redux";
import { Button, Grid, Paper } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import {
  branchInitialValues,
  branchMandatoryFields,
  branchProperties,
  branchValidationSchema,
} from "./helper";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { useMutation } from "@apollo/client";
import { CREATE_BRANCH } from "utils/graphql/services/entities/mutations";
import entitesClient from "utils/graphql/entitiesClient";
import { isEmpty } from "utils/helpers";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import { useHistory } from "react-router-dom";
import { isFieldsValidate } from "shared/organisms/dynamicform/helper";
import { metadataSuccess } from "app-component/slices/metadata-slice";
import { useEffect } from "react";
import LoadingButton from "@mui/lab/LoadingButton";

export const BranchCreate = () => {
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    branchInitialValues,
    branchValidationSchema,
    ""
  );
  const { isLoading, data: metaData }: any = useAppSelector(
    (state) => state.metadataReducer
  );
  const dispatch = useAppDispatch();
  const history = useHistory();

  const updateMetaData = (listData, metaKey) => {
    let metadataList = { ...metaData };
    metadataList[metaKey] = listData;
    dispatch(metadataSuccess(metadataList));
  };

  const [createBranch, { loading, error, data }] = useMutation(CREATE_BRANCH, {
    client: entitesClient, // Ensure you use the correct GraphQL client instance
  });
  const getValueFromMetadata = (
    listValue,
    identifier,
    identifierValue,
    searchValue
  ) => {
    const maindata = metaData[`${listValue}`];
    const filteredData=maindata?.filter((obj)=>{
      if(obj[`${identifier}`]==identifierValue){
        return obj;
      }
    });
    return  filteredData[0]?.[`${searchValue}`]
  };

  const handleCreateBranch = async () => {
    try {
      const response:any = await createBranch({
        variables: {
          input: {
            name: watch()?.name,
            District: watch()?.district,
            State: getValueFromMetadata("state_list", "state_id", watch()?.state,"state_id"),
            sbdCollegeId:watch()?.sbdCollegeId,
            sbdDistrictId: getValueFromMetadata("district_list", "district_id", watch()?.district,"sbd_district_id"),
            sbdStateId: getValueFromMetadata("state_list", "state_id", watch()?.state,"sbd_state_id"),
          },
        },
      });
      if(!isEmpty(response?.data?.createBranch)){
        dispatch(snackbarRequest({ message: "Created Branch successfully" }));
        history.replace(`/entities/branch`);
      }else{
        dispatch(snackbarRequest({ message: `${response?.errorReason}`,type: "error"  }));
      }
    } catch (err:any) {
      dispatch(snackbarRequest({ message: `${err?.message}`,type: "error"  }));
    }
  };
  useEffect(()=>{
    if(watch()?.state==""){
      updateMetaData([],"district_list");
    }
  },[watch()?.state]);

  return (
    <div>
      <TypographyHeading>Create branch</TypographyHeading>
      <Paper elevation={2} sx={{ px: 2, pb: 2, pt: 2 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={branchProperties}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
          <ContentRight sx={{ mt: 0 }}>
            <LoadingButton
              variant="contained"
              loadingPosition="start"
              loading={loading}
              sx={{
                width: "180px",
                height: "40px",
                marginTop: "15px",
                marginRight: "10px",
                padding: "7px 23.5px 7px 23.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleCreateBranch}
              disabled={!isFieldsValidate(errors, branchMandatoryFields, getValues)}
            >
              Create Branch
            </LoadingButton>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
};
